import React, {useEffect, useRef, useState} from 'react';
import {getStateByPath} from "../../../../redux/selectors";
import {connect, useSelector} from "react-redux";
import {
    ADD_STATE, REMOVE_STATE,
    setFilter,
    setForm,
    setItem, setLoading,
    setTableParams,
    setViewMode
} from "../../../../redux/actions/generics/IndexedActions";
import { Collapse, Spinner} from "reactstrap";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {moduleMenuService} from "../../../../jwt/_services/configuration/moduleMenuService";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {MenuSectionForm} from "./_form";
import {TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {menuOptionsProvider} from "../../../../providers/menuOptionsProvider";
import {GenericContainer} from "../../../../components/containers/GenericContainer";
import {mockModuleMenuResponse} from "../../../develop/componentCatalog/mockups";

const ModuleMenuSection = (props) => {
    const path = props?.path + '/menu';
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {  domainObject } = parentComponentState?.data || {};
    // const { showOrder } = parentComponentState?.data?.listDomainObjects?.length || 0;
    const {  listDomainObjects } = componentState?.data || [];
    const {  loading, filter } = componentState?.data || {};


    const [menuId, setMenuId] = useState(null);

    const [showSelect, setShowSelect] = useState(false);
    const [showFormModal, setShowFormModal] = useState(true);
    const formModalRef = useRef(null);


    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);


    useEffect( () => {
        if( !domainObject?.id )
            return

        props.setFilter(path , {
            module : { id : domainObject?.id }
        });
    }, [ domainObject ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, moduleMenuService, 0, 1000, filter)
    }, [ filter ]);

    const selectItem = () => {
        if (!menuId)
            return;

        const dataRequest = {
            module      : { id: domainObject.id },
            menu        : { id: menuId },
            showOrder   : (listDomainObjects?.length || 0)
        }

        genericIndexedActions.save(path, moduleMenuService, dataRequest)

        setMenuId(null);
        setShowSelect(false);
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);

        setShowFormModal(true);
        formModalRef.current.showModal(null, listDomainObjects?.length || 0, domainObject);
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        setShowFormModal(true);
        formModalRef.current.showModal(data, listDomainObjects?.length || 0, domainObject);
    }

    const removeItem = (data) => {
        genericIndexedActions.delete(path, moduleMenuService, data.id, '')
    }


    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, moduleMenuService, dataRequest)
    }

    const notImplemented = (data) => {
        console.log('Not implemented', data);
    }

    const renderContent = (_option, index) => {
        return (
            <div className={'module-menu-item'}>
                <label className="module-menu-item-title">
                    <h3><i className={"fas " + _option.icon + " mr-4"}/></h3>
                    <h3>{_option.name}</h3>
                </label>
                <div className="float-right">
                    <GenericButton
                        style={'table'}
                        toolTip={TT_EDIT}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={_ => editItem(_option, index)}/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => removeItem(_option)}
                    />
                </div>
            </div>
        )
    }

    return (<>
        {
            loading ? <Spinner animation="border"/> : <>
                <GenericContainer
                    titlle={'Menus'}
                    listItems={listDomainObjects}
                    renderContent={renderContent}

                    provider={menuOptionsProvider}
                    option={menuId}
                    setOption={setMenuId}
                    onAddItem={selectItem}

                    onCreateItem={createItem}
                    onReorderItems={onReorder}
                />
                {/*<div className={'module-menu-section'}>*/}
                {/*    <div className={'module-menu-header'}>*/}
                {/*        <h2>{'Menus'}</h2>*/}
                {/*        <div className={'top-right-header'}>*/}
                {/*            <GenericButton*/}
                {/*                style={'success-secondary'}*/}
                {/*                label={'Agregar'}*/}
                {/*                toolTip={'Agrega un menu existente'}*/}
                {/*                icon={ showSelect ? 'fa-chevron-up' : 'fa-chevron-down'}*/}
                {/*                permission={'add'}*/}
                {/*                onClick={_ => setShowSelect(!showSelect)}/>*/}
                {/*            <GenericButton*/}
                {/*                style={'success-secondary'}*/}
                {/*                label={'Nuevo'}*/}
                {/*                toolTip={'Genera un nuevo menu'}*/}
                {/*                icon={'fa-plus'}*/}
                {/*                permission={'add'}*/}
                {/*                onClick={_ => createItem()}/>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <div className={'module-menu-list'}>*/}
                {/*        <Collapse isOpen={showSelect}>*/}
                {/*            <SelectGeneric*/}
                {/*                initialValue={ menuId }*/}
                {/*                setExternalValue={ setMenuId }*/}
                {/*                provider={ menuOptionsProvider }*/}
                {/*            />*/}
                {/*            <GenericButton*/}
                {/*                style={'success-secondary'}*/}
                {/*                toolTip={'Agregar'}*/}
                {/*                icon={'fa-plus'}*/}
                {/*                permission={'add'}*/}
                {/*                onClick={_ => selectItem()}/>*/}
                {/*        </Collapse>*/}
                {/*        {*/}
                {/*            listDomainObjects?.length > 0 &&*/}
                {/*            <DragDropList*/}
                {/*                items={listDomainObjects?.sort((a, b) => a?.showOrder - b?.showOrder)}*/}
                {/*                renderContent={renderContent}*/}
                {/*                onReorder={onReorder}*/}
                {/*                orientationHV={'vertical-container'} // CSS class para orientar los elementos horizontalmente*/}
                {/*                className={''}*/}
                {/*            />*/}
                {/*        }*/}
                {/*    </div>*/}
                {/*</div>*/}
            </>
        }
        {
            showFormModal && <MenuSectionForm
                path={path}
                category={domainObject}

                ref={formModalRef}
            />
        }
    </>)
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(ModuleMenuSection)